(() => {
  const selector = '[data-bc-piece-quantity]';
  function valid(input) {
    const n = Number(input.value);
    return Number.isInteger(n) && n >= 12 && n % 12 === 0;
  }
  function check(input, report) {
    const ok = valid(input);
    input.setCustomValidity(ok ? '' : input.dataset.bcQuantityError);
    if (!ok && report) input.reportValidity();
    const total = input.closest('form')?.querySelector('[data-bc-order-total]');
    if (total) {
      const cents = Number(input.dataset.bcUnitCents);
      total.textContent = ok ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:input.dataset.bcCurrency || 'USD'}).format(cents * Number(input.value) / 100) : '—';
    }
    return ok;
  }
  document.addEventListener('input', e => { if(e.target.matches(selector)) check(e.target, false); }, true);
  document.addEventListener('change', e => { if(e.target.matches(selector) && !check(e.target, true)) {e.preventDefault(); e.stopImmediatePropagation();} }, true);
  document.addEventListener('submit', e => {
    const bad = [...e.target.querySelectorAll(selector)].find(input => !check(input, false));
    if (bad) { e.preventDefault(); e.stopImmediatePropagation(); bad.reportValidity(); }
  }, true);
  document.addEventListener('click', e => {
    if (!e.target.closest('[name="checkout"],a[href*="/checkout"]')) return;
    const bad = [...document.querySelectorAll('form[action*="/cart"] '+selector)].find(input => !check(input, false));
    if (bad) { e.preventDefault(); e.stopImmediatePropagation(); bad.reportValidity(); }
  }, true);
  function init() { document.querySelectorAll(selector).forEach(input => check(input, false)); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
